import React from "react";
import { FaTimesCircle,FaArrowDown,FaSync,FaEye } from "react-icons/fa";
import { Dialog } from 'primereact/dialog';
import {DynamicHorizontalTable2} from './dynamictables';

export const OutOfStockBadge = ({value,refreshFun,viewdata,isloading}) => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    
  
    
  return (
    <>
    {console.log("OutOfStockBadge viewdata:", viewdata)}
    <Dialog visible={modalIsOpen} position='right' modal style={{ width: '100rem' }} onHide={() => { if (!modalIsOpen) return; setModalIsOpen(false); }}>
    <div class="container">
        {modalIsOpen ? DynamicHorizontalTable2({ data: viewdata }) : <></>}
        
    </div>
    </Dialog>
    <span style={styles.badge}>
      <FaArrowDown style={styles.icon}/>
      {value}
      {isloading ? <span>Loading...</span> : (<> <FaSync style={styles.icon}  onClick={refreshFun}/>
      &nbsp;
      &nbsp;          
      <FaEye style={styles.icon}  onClick={() => setModalIsOpen(true)}/></>)}  
     
    </span>
    </>
  );



};

const styles = {
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 10px",
    backgroundColor: "#fdecea",
    color: "#d32f2f",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "600",
  },
  icon: {
    fontSize: "14px",
  },
};


